import moment from 'moment';

class VoucherHotelAnalytics {

    constructor() {
        this.data = window.__pt.data || {};
        this.site = window.__pt.settings.site || {};
    }


    HotelTransactionDestination(args) {
        let reservation = this.getReservation(args);

        let event = {
            eventAction: "Hotel",
            eventCategory: "Hotels Transaction by Destination",
            eventInteraction: false,
            eventLabel: `${reservation.hotelName}, ${reservation.displayText} | ${reservation.week} | p${reservation.placeID} | ${reservation.bookingId}`,
            eventValue: Math.trunc(reservation.totalAmount),
            event: "gtmEvent",
            eventName: "gtmEvent",
        };

        this.setDataLayer(event)
    }

    HotelTransaction(args) {
        let reservation = this.getReservation(args);

        let event = {
            eventAction: "Hotel",
            eventCategory: "Hotels Transaction",
            eventInteraction: false,
            eventLabel: `${reservation.hotelName}, ${reservation.displayText} | ${reservation.week} | p${reservation.placeID} | ${reservation.bookingId}`,
            eventValue: Math.trunc(reservation.totalAmount),
            event: "gtmEvent",
            eventName: "gtmEvent",
        };

        this.setDataLayer(event)
    }

    HotelFunnel(args) {
        let reservation = this.getReservation(args);

        let event = {
            eventAction: `ReservacionCompletada | hotelId:${reservation.hotelId} | ${reservation.hotelName} | ${reservation.city}`,
            eventCategory: "Hotels Payment Funnel",
            eventInteraction: false,
            eventLabel: `${reservation.checkinFormat}, ${reservation.checkoutFormat} | adults:${reservation.adults} | kids:${reservation.children} | RAPA | ${reservation.bookingId}`,
            eventValue: Math.trunc(reservation.totalAmount),
            event: "gtmEvent",
            eventName: "gtmEvent",
        };
        
        this.setDataLayer(event)
    }

    hotelRemarketing(args) {
        let reservation = this.getReservation(args);
        let origin = window.location.origin;

        let event = {
            ArrivalId: reservation.displayId,
            ArrivalName: reservation.city,
            Category: reservation.stars ? reservation.stars.toString() : "0",
            CheckIn: reservation.checkinFormat,
            CheckOut: reservation.checkoutFormat,
            ConversionAmount: reservation.totalAmount,
            ConversionCurrency: reservation.currency,
            Currency: reservation.currency,
            Destination: reservation.displayText,
            DestinationId: reservation.displayId,
            DestinationUrl: `${origin}/hoteles/${reservation.uriPlace}`,
            eventName: "HotelThankYouPage",
            HotelId: reservation.hotelId,
            HotelName: reservation.hotelName,
            HotelUrl: `${origin}/hotel/${reservation.uri}`,
            ImageUrl: reservation.image,
            IsWeekend: reservation.isWeekend,
            MealPlan: reservation.mealPlanCode,
            //PayForm: "CreditCard", // preguntar
            //PayPlan: "1",
            ProductId: `${reservation.placeID}-${reservation.week}`,
            Rapa: !reservation.isReserveNowPayLater,
            Rapd: reservation.isReserveNowPayLater,
            ReservationId: reservation.bookingId.toString(),
            RoomType: reservation.roomType, // ver id del cuarto
            TotAmount: Math.trunc(reservation.totalAmount),
            TotalAdults: reservation.adults,
            TotalAmount: reservation.totalAmount,
            TotalChilds: reservation.children,
            TotalRooms: reservation.roomsCount,
            RoomId: reservation.roomId,
            TripDays: reservation.days,
            Week: reservation.week.toString(),
            ChannelId: reservation.channelId,
            event: "checkoutStep3",
        }
        this.setDataLayer(event)
    }


    facebookEvent(args) {

        let reservation = this.getReservation(args);

        let event = {
            FacebookCheckIn: reservation.week.toString(),
            FacebookCheckOut: "",
            FacebookContentCategory: "",
            "FacebookContentIds.0": `${reservation.placeID}-${reservation.week}`,
            FacebookContentName: `hotel:${reservation.hotelName}, ${reservation.displayText}`,
            FacebookContentType: "product",
            FacebookCurrency: reservation.currency,
            FacebookEventType: "Purchase",
            FacebookNumItems: reservation.roomsCount, 
            FacebookOrderId: "",
            FacebookSearchString: "",
            FacebookStatus: "False",
            eventName: "gtmEvent",
            FacebookValue: Math.trunc(reservation.totalAmount)
        }

        this.setDataLayer(event)
    }

    setVoucherAnalytics(args) {
        this.applyEvents(args);
        this.HotelTransactionDestination(args);
        this.HotelTransaction(args);
        this.HotelFunnel(args);
        this.hotelRemarketing(args);
        this.facebookEvent(args);
    }


    getBaseDefault(args = {}) {
        let info = args.info || {};
        return {
            reservationId: info.id,
            email: info.email,
        }
    }

    getReservation(args = {}) {
        let reservation = args.reservation || {};
        let hotelInformation = reservation.hotelInformation || {};
        let quote = args.quote || {};
        let place = args.placeContainer || {};
        let placeID = args.placeID || 0;
        let checkinMoment = moment(hotelInformation.startDate);
        let checkoutMoment = moment(hotelInformation.endDate);
        let info = args.info;
        return {
            displayText: place.displayText,
            displayId: place.id,
            type: place.type,
            uriPlace: place.uri,
            placeID: placeID,
            bookingId: reservation.bookingId,
            channelId: reservation.channelId,
            createdDate: reservation.createdDate,
            currency: reservation.currency,
            customerEmail: reservation.customerEmail,
            customerFirstName: reservation.customerFirstName,
            customerLastName: reservation.customerLastName,
            minServiceDate: reservation.minServiceDate,
            organizationId: reservation.organizationId,
            adults: hotelInformation.adults,
            description: hotelInformation.description,
            checkout: hotelInformation.endDate,
            checkin: hotelInformation.startDate,
            mealPlanCode: hotelInformation.mealPlanCode,
            mealPlan: hotelInformation.mealPlan,
            hotelName: quote.name,
            uri: quote.uri,
            image: quote.image,
            hotelId: quote.hotelId,
            address: `${quote.location.city}, ${quote.location.state}, ${quote.location.country}`,
            city: quote.location.city,
            uriDetail: `${i18n.url.url_detail}${quote.uri}`,
            isWeekend: (checkinMoment.day() === 6) || (checkinMoment.day() === 0),
            adults: hotelInformation.adults,
            children: hotelInformation.kids,
            roomsCount: hotelInformation.roomsCount,
            week: checkinMoment.week(),
            checkinFormat: checkinMoment.format('YYYY-MM-DD'),
            checkoutFormat: checkoutMoment.format('YYYY-MM-DD'),
            days: checkoutMoment.diff(checkinMoment, 'days'),
            stars: quote.stars,
            totalAmount: hotelInformation.serviceAmountTotal,
            roomType: hotelInformation.serviceCarrierCode,
            roomId: info.roomID,
            isReserveNowPayLater: reservation.reserveNowPayLater,
            channelId: reservation.channelId
        }
    }

    applyEvents(args) {
        let events = args.reservation.events || [];
        let eventsLength = events.length;

        for (var i = 0; i < eventsLength; i++) {
            const event = { ...events[i] } //Para elimininar props que le a�ade vuejs 
            this.setDataLayer(event)
        }

    }

    onError(error, data, step) {
        const error_summary = {
            message: error.message,
            email: error.info.email,
            id: error.info.id,
        }

        const data_summary = {
            em: data.em,
            id: data.id
        }
        const payload = JSON.stringify(error_summary || { results: "none" });
        const quote_params = JSON.stringify(data_summary || { params: "none" });

        const event = {
            event: "gtmEvent",
            eventName: 'gtmEvent',
            eventCategory: "Hotels Error",
            eventAction: quote_params ,
            eventLabel: `step:${step} - ${payload}`
        }


        this.setDataLayer(event);
    }


    setDataLayer(args) {
        if (window.dataLayer) {
            dataLayer.push(args)
        }
    }

}

export const VoucherHotelAnalytic = new VoucherHotelAnalytics();